import React, { useCallback, useState } from 'react'
import { formatBytes } from '../utils/formatBytes'
import { MetadataItem } from './MetadataItem'
import { MediaItemData } from '../models/mediaItemData'
import styled from 'styled-components'
import { Video } from './Video'
import { useHistory } from 'react-router-dom'

const Container = styled.div`
  cursor: pointer;
  background-color: white;
  display: flex;  
  gap: 15px;
`

const LinesContainer = styled.div`
  padding: 15px 0;
  cursor: pointer;
  background-color: white;
  display: flex;
  flex-direction: column;
  gap: 15px;
`

const MainLine = styled.div`
  font-weight: 500;
  display: flex;
  gap: 8px;
  align-items: center;
`

const MetadataLine = styled.div`
  display: flex;
  gap: 8px;
`

const VideoContainer = styled.div`
  flex: 0 0 100px;
`

export const MovieItem = ({ title, url, size, id }: MediaItemData): JSX.Element => {
  const [isHover, setIsHover] = useState(false)

  const history = useHistory()

  const handleClick = useCallback(
    () => history.push(`/${id}`),
    [history, id]
  )

  return (
    <Container onClick={handleClick}
               onMouseEnter={() => setIsHover(true)}
               onMouseLeave={() => setIsHover(false)}
               onTouchStart={() => setIsHover(true)}
               onTouchEnd={() => setIsHover(false)}
    >
      <VideoContainer>
        <Video url={url} showPreview={isHover} />
      </VideoContainer>
      <LinesContainer>
        <MainLine>
          <span>{title}</span>
        </MainLine>
        <MetadataLine>
          <MetadataItem itemKey="גודל הקובץ" itemValue={formatBytes(size)} />
          <MetadataItem itemKey="תאריך צילום" itemValue="לא ידוע" />
        </MetadataLine>
      </LinesContainer>
    </Container>
  )
}
